import homeworkReducer from './';

export default homeworkReducer;
